import getMetricListsRef from './getMetricListsRef';
import getExcludedPaceDatesRef from './getExcludedPaceDatesRef';
import getScorecardsRef from './getScorecardsRef';
import getGoalsRef from './getGoalsRef';
import getDashboardGadgetsRef from './getDashboardGadgetsRef';
import getReportGadgetsRef from './getReportGadgetsRef';
import getVisCacheVersionRef from './getVisCacheVersionRef';

const visualisationDefinitionsStore = {
  getMetricListsRef,
  getScorecardsRef,
  getGoalsRef,
  getDashboardGadgetsRef,
  getReportGadgetsRef,
  getExcludedPaceDatesRef,
  getVisCacheVersionRef,
};

export default visualisationDefinitionsStore;
